import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const NotFound: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-b from-black to-primary p-8">
      <div className="max-w-2xl text-center text-white">
        <h1 className="text-4xl font-bold mb-4">{t('notFoundPage.title')}</h1>
        <p className="mb-6 text-lg">{t('notFoundPage.message')}</p>
        <Link
          to="/"
          className="inline-block bg-[#1E90AA] text-white py-2 px-4 rounded hover:bg-[#176F8A]"
        >
          {t('notFoundPage.homeButton')}
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
